import { Link } from "react-router-dom";

const shouldHideSupportButton = (
  search: string = window.location.search,
): boolean => {
  const searchParams = new URLSearchParams(search);

  const hideParams = ["billing/choose-plan"];

  return hideParams.some((param) => searchParams.has(param));
};

const year = new Date().getFullYear();

const Footer = () => {
  const hideSupport = shouldHideSupportButton();

  return (
    <div
      className=" text-center dark:text-white/60 my-3 mt-5 pb-3"
      style={{ fontSize: "14px" }}
    >
      © {year} Netsights.ai. All rights reserved
      {!hideSupport && (
        <>
          {" "}
          |{" "}
          <Link
            to="/support"
            className="text-blue-600 hover:underline"
          >
            Support
          </Link>
        </>
      )}
    </div>
  );
};

export default Footer;
